import { groupBy, prop } from 'ramda';
import { TARGET_CHANNELS } from '../constants/targetChannels';

export const createMockEntitiesArray = (length) => {
  return [...new Array(length).keys()].map((item) => ({ id: `id-${item}` }));
};

export const getAvailableGames = ({
  games = [],
  categories = [],
  providers = [],
  isDesktop = false,
}) => {
  const categoriesMap = groupBy(prop('id'))(categories);
  const providersMap = groupBy(prop('id'))(providers);

  return games.filter((game) => {
    const gameCategories = game?.category ?? [];
    const gameProvider = game?.provider ?? '';

    if (!providersMap[gameProvider]) {
      return false;
    }

    const isCategoryAvailable = gameCategories.some(
      (categoryId) => !!categoriesMap[categoryId]
    );

    if (!isCategoryAvailable) {
      return false;
    }

    if (isDesktop && game?.targetChannel === TARGET_CHANNELS.MOBILE) {
      return false;
    }

    if (!isDesktop && game?.targetChannel === TARGET_CHANNELS.DESKTOP) {
      return false;
    }

    return true;
  });
};
